import type {ComponentProps, FC} from 'react';

import {cn} from '@/modules/foundation/shared/tailwind';

export type CallToActionGroupProps = ComponentProps<'div'>;

export const CallToActionGroup: FC<CallToActionGroupProps> = ({className, children, ...rest}) => {
	return (
		<div className={cn(['flex', 'gap-4', 'flex-wrap', 'mb-4', className])} {...rest}>
			{children}
		</div>
	);
};
